((scope)=>{
  const filter=(ranges,f)=>ranges.map(range=>{
    if(f.style&&range.style!==f.style)return {range,designs:[]};
    const words=(f.search||'').trim().toLowerCase().split(/\s+/).filter(Boolean);
    const designs=range.designs.filter(d=>{
      const text=`${range.name} ${range.style} ${range.description} ${d.name} ${d.colours.join(' ')}`.toLowerCase();
      return words.every(w=>text.includes(w))&&(!f.colour||d.colours.includes(f.colour))&&(!f.size||d.sizes.some(s=>s.id===f.size));
    });return {range,designs};
  }).filter(r=>r.designs.length);
  const api={filter};if(typeof module!=='undefined'&&module.exports)module.exports=api;else scope.McGinleyRugIndexModel=api;
})(typeof globalThis!=='undefined'?globalThis:this);
